import React from 'react';
import { Text } from '../../../../CommonComponents/OPL/Text/Text';
import { Box } from '../../../../CommonComponents/OPL/Box/Box';
import { Button } from '../../../../CommonComponents/OPL/Button/Button';

interface JointAccountsInviteProps {
  onInvite(): void;
}

export const JointAccountsInvite = ({ onInvite }: JointAccountsInviteProps) => {
  return (
    <Box display="flex" flexDirection="column" alignItems="center" mt="40" mb="24">
      <Text fontSize="h6" color="neutral.600" fontWeight={500}>
        Joint Accounts?
      </Text>

      <Button variant="link" onClick={onInvite} mt="8">
        Check Our Alignment -&gt;
      </Button>
    </Box>
  );
};
